import { Grid, Paper } from '@material-ui/core';
import { useState } from 'react';
import EditContractPopup from '../EditContractPopup';
import ReadinessConfig from '../ReadinessConfig/ReadinessConfig';
import ContractCardStyle from './ContractCardStyle';
import CheckInConfig from 'features/clients/clientConfigs/CheckIn';
import CheckInSLABridge from '../EditContractPopup/EditWorkFlowPopup/CheckInSLABridge';
import { StepDefinitionTypeById } from '../enums';
import EditWorkFlowPopup from '../EditContractPopup/EditWorkFlowPopup/EditWorkFlowPopup';
import IssueTrackerConfig from '../IssueTrackerConfig/IssueTrackerConfig';
import WashConfigDialog from 'features/clients/clientConfigs/washes/WashConfigDialog';

const useStyles = ContractCardStyle;

const ContractCard = ({ contract, clientConfig, setClientConfig }) => {

    const classes = useStyles();

    const [open, setOpen] = useState(false);

    const handleClose = () => {
        setOpen(false);
    }

    const componentPerConfig = {
        "checkinConfig":
            <CheckInSLABridge
                clientConfig={clientConfig}
                contract={contract}
                open={open}
                handleClose={handleClose}
            />,
        "checkoutConfig":
            <EditWorkFlowPopup
                stepDefinitionTypeId={StepDefinitionTypeById.CHECKOUT}
                clientConfig={clientConfig}
                contract={contract}
                open={open}
                handleClose={handleClose}
            />,
        "readiness": <ReadinessConfig
            contract={contract}
            open={open}
            clientConfig={clientConfig}
            name={contract.configName}
            handleClose={handleClose}
        />,
        "conditionalReport":
            <CheckInConfig
                contract={contract}
                open={open}
                clientConfig={clientConfig}
                name={contract.configName}
                handleClose={handleClose}
            />,
        "issueTrackerConfig":
            <IssueTrackerConfig
                contract={contract}
                open={open}
                clientConfig={clientConfig}
                name={contract.configName}
                handleClose={handleClose}
            />,
        // "mechanicals": <MechanicalWorkConfig
        //     contract={contract}
        //     open={open}
        //     clientConfig={clientConfig}
        //     name={contract.configName}
        //     handleClose={handleClose}
        // />
        "washConfig": <WashConfigDialog
            contract={contract}
            open={open}
            clientConfig={clientConfig}
            name={contract.configName}
            handleClose={handleClose}
        />,
    }

    const usingCustomForms = contract.isUsingCustom && contract.isUsingCustom(clientConfig);
    const usingPaveCheckIn = contract.isUsingPave && contract.isUsingPave(clientConfig);
    const on = contract.isOn && contract.isOn(clientConfig) || usingCustomForms || usingPaveCheckIn;

    return (
        <>
            <Paper className={`${classes.card}`} onClick={() => setOpen(true)}>
                <Grid container alignItems='center'>
                    <Grid item xs={2} display="flex" className={classes.iconContainer}>
                        {contract.icon ?? <img src="/icons/icon-detailing.svg" alt="Transporter" />}
                    </Grid>
                    <Grid item xs={10}>
                        <div className={classes.title}>{`${contract.label} SLA`}</div>
                        {on && <div className={classes.activeWrapper}>
                            <div className={classes.activeIcon}></div>
                            <div>{`Active ${usingPaveCheckIn ? "- PAVE" : ""}${(usingCustomForms && !usingPaveCheckIn) ? "- Custom Form" : ""}`}</div>
                        </div>}
                    </Grid>
                </Grid>
            </Paper>
            {
                componentPerConfig[contract.configName] ? <>{componentPerConfig[contract.configName]}</> :
                    <EditContractPopup
                        contract={contract}
                        setOpen={setOpen}
                        open={open}
                        clientConfig={clientConfig}
                        setClientConfig={setClientConfig}
                        name={contract.configName}
                    />
            }
        </>
    );
};

export default ContractCard;


